import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { AddonInterface, setEditId, setEditError, selectAddonById } from "../../../store/mine_craft/addonsSlice";
import { updateAddon, fetchAddon } from "../../../actions/mine_craft/addonsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch  = useAppDispatch();
  const location  = useLocation();
  const id: any   = useAppSelector(state => state.mineCraft.addons.editId);
  const error     = useAppSelector(state => state.mineCraft.addons.editError);
  const addon     = useAppSelector(state => id ? selectAddonById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchAddon(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: AddonInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: AddonInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateAddon({ id, data: formData }));

    if (updateAddon.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-addon'>
        <h6 className="v-content-label">Edit Addon</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={addon} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
